import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const NotificationPreferences = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.notificationPreferences')} />;
};

export default NotificationPreferences;
